import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import Container from './Container';
import { useLanguage } from '../../contexts/LanguageContext';
import logo from '../../assets/images/logo2.png';
import './Footer.css';

const Footer = () => {
    const { t } = useLanguage();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <Container>
                <div className="footer__grid">
                    <div className="footer__col footer__col--info">
                        <Link to="/" className="footer__logo">
                            <div className="footer__logo-wrapper">
                                <img src={logo} alt="Da Vinci Institute" />
                            </div>
                            <strong className="footer__logo-text">Da Vinci <span style={{ color: 'var(--color-neutral-400)', fontWeight: 'var(--font-medium)' }}>   INSTITUTE</span></strong>
                        </Link>
                        <p className="footer__desc">
                            {t('hero.subtitle')}
                        </p>
                        <div className="footer__socials">
                            <a href="https://www.facebook.com/davinciinst" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebook /></a>
                            <a href="https://www.instagram.com/davinci_institute/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
                            <a href="https://www.linkedin.com/company/da-vinci-institute/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
                        </div>
                    </div>

                    <div className="footer__col">
                        <h4 className="footer__title">{t('nav.departments')}</h4>
                        <ul className="footer__links">
                            <li><Link to="/departments/computer-science">Computer Science</Link></li>
                            <li><Link to="/departments/oil-gas">Oil & Gas Science</Link></li>
                            <li><Link to="/departments/management">Management</Link></li>
                            <li><Link to="/departments/accounting">Accounting</Link></li>
                        </ul>
                    </div>

                    <div className="footer__col">
                        <h4 className="footer__title">Quick Links</h4>
                        <ul className="footer__links">
                            <li><Link to="/">{t('nav.home')}</Link></li>
                            <li><Link to="/about">{t('nav.about')}</Link></li>
                            <li><Link to="/departments">{t('nav.departments')}</Link></li>
                            <li><Link to="/contact">{t('nav.contact')}</Link></li>
                        </ul>
                    </div>

                    <div className="footer__col">
                        <h4 className="footer__title">{t('sections.getInTouch')}</h4>
                        <ul className="footer__contact">
                            <li>
                                <span className="material-icons footer__contact-icon">location_on</span>
                                {t('contact.address')}
                            </li>
                            <li>
                                <span className="material-icons footer__contact-icon">phone</span>
                                +964 750 335 8885
                            </li>
                            <li>
                                <span className="material-icons footer__contact-icon">email</span>
                                info@dvinst.com
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footer__bottom">
                    <p className="footer__copyright">
                        &copy; {currentYear} Da Vinci Institute. All rights reserved.
                    </p>
                    <div className="footer__bottom-links">
                        <a href="#">Privacy Policy</a>
                        <a href="#">Terms of Service</a>
                    </div>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;
